var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophy = function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.327 1.953a.667.667 0 0 0-.667.667v.666h-.562A2.1 2.1 0 0 0 1.994 5.39v.563c0 1.81 1.021 3.14 2.944 3.314a3.31 3.31 0 0 0 2.388 1.955l.001 1.398H5.994a.667.667 0 0 0 0 1.333h4a.667.667 0 0 0 0-1.333H8.66l.006-1.394a3.28 3.28 0 0 0 2.376-1.949c1.906-.156 2.952-1.513 2.952-3.324V5.39a2.1 2.1 0 0 0-2.104-2.104h-.563V2.62a.667.667 0 0 0-.667-.667zm.667 1.333h4v4.667a2 2 0 1 1-4 0zM4.098 4.62h.562l-.002 3.264c-.897-.219-1.331-.908-1.331-1.93V5.39c0-.43.34-.77.77-.77m7.229 0h.563c.43 0 .77.34.77.77v.563c0 1.023-.43 1.713-1.327 1.932z"
  })));
};
export default SvgTrophy;